module.exports = __webpack_public_path__ + "prod/1.42.2/img/superiority1.7e5c514e.png";